import { CardTable } from '../../../../components/card-table';
import { gewastypes } from '../settings';
import { GewasType } from './components/gewasType';

export const TeeltenVanggewassen = ({ isKlwReadOnly, isLoading }) => {
  return (
    <CardTable>
      <CardTable.Header>
        <CardTable.Header.Title
          infoContent={
            <>
              <h4>Algemeen</h4>
              <p>
                Hier kunt u de voor- / na- en vanggewassen opgeven bij de hoofdteelten productiegrasland, snijmais, en akkerbouw. Het areaal van de hoofdteelten
                heeft u opgegeven bij 'Areaal' binnen kringloopwijzer. Deze dienen overeen te komen met de registratie bij de gecombineerde opgave (GO) bij RVO.
              </p>
              <p>
                Door het invullen van dit blok wordt de opbrengst en de bemesting van gewassen aan de juiste hoofdteelten toegewezen. De opbrengst betreft de
                netto hoeveelheden geoogst product voor conservering in het kringloopwijzerjaar. Deze hoeveelheden zijn onderdeel van de aangelegde voorraden
                en/of afgevoerde producten. De bemesting van voor- / na- en vanggewassen dienen per hoofdteelt te worden opgeven bij het menuonderdeel mest. Als
                u hier gegevens invoert dan wordt het bij bemesting getoond.
              </p>

              <h4>Productiegrasland</h4>
              <p>Achtereenvolgens kiest u hier:</p>
              <ul>
                <li>Teelttype; betreft het een voor of een nagewas.</li>
                <li>Gewastype; keuze mogelijkheid snijmais of akkerbouw</li>
                <li>Gewasgroep; Indien gewastype akkerbouw dient u ook de gewasgroep te selecteren.</li>
                <li>Oppervlakte [ha]; geef hier oppervlakte op.</li>
              </ul>
              <p>Het totaal van alle oppervlaktes kan niet groter zijn dan het areaal productiegrasland.</p>
              <p>
                U kunt meerdere gewassen toevoegen met de knop 'gewas toevoegen'. Met de switch 'normatief / opgeven' maakt u de keuze om de opbrengsten van
                gewassen op te geven of normatieve waardes te gebruiken. Als u kiest voor *'opgeven'* dan dient u de opbrengst aan kg ds, N, P, VEM op te geven.
                Let op: de eenheden van de velden.
              </p>

              <h4>Snijmais</h4>
              <p>Achtereenvolgens kiest u hier:</p>
              <ul>
                <li>Teelttype; betreft het een voor of een nagewas, vanggewas niet geoogste producten.</li>
                <li>Gewastype; keuze mogelijkheid grasland of akkerbouw</li>
                <li>Gewasgroep; Indien gewastype akkerbouw dient u ook de gewasgroep te selecteren.</li>
                <li>Oppervlakte [ha]; geef hier oppervlakte op.</li>
              </ul>
              <p>Het totaal van alle oppervlaktes kan niet groter zijn dan het areaal snijmais.</p>
              <p>
                U kunt meerdere gewassen toevoegen met de knop 'gewas toevoegen'. Bij snijmais worden de opbrengsten normatief berekent, u kunt geen keuze
                maken.
              </p>

              <h4>Akkerbouw</h4>
              <p>Achtereenvolgens kiest u hier:</p>
              <ul>
                <li>Teelttype; betreft het een voor of een nagewas, vanggewas niet geoogste producten.</li>
                <li>Gewastype; keuze mogelijkheid grasland of snijmais.</li>
                <li>Oppervlakte [ha]; geef hier oppervlakte op.</li>
              </ul>
              <p>Het totaal van alle oppervlaktes kan niet groter zijn dan het areaal akkerbouw.</p>
              <p>
                U kunt meerdere gewassen toevoegen met de knop 'gewas toevoegen'. Bij akkerbouw worden de opbrengsten normatief berekent, u kunt geen keuze
                maken.
              </p>
            </>
          }>
          Voor- en nateelten, vanggewassen
        </CardTable.Header.Title>
      </CardTable.Header>
      {gewastypes.map(type => (
        <GewasType isLoading={isLoading} isKlwReadOnly={isKlwReadOnly} type={type} />
      ))}
    </CardTable>
  );
};
